<div class="slip-component-general-container">
  <div class="d-flex">
    <account-menu-selection-utils
      [selectedItem]="this.selectedSlipType"
      [selectionList]="this.slipTypeListB3000"
      (selectionChange)="this.onSlipTypeChange($event)"></account-menu-selection-utils>
    <ng-container [ngSwitch]="['b500', 'terminalPeru'] | getProductName">
      <ng-container *ngSwitchCase="'b500'"></ng-container>
      <ng-container *ngSwitchCase="'terminalPeru'"></ng-container>
      <ng-container *ngSwitchDefault>
        <account-menu-selection-utils
          [selectedItem]="this.selectedSlipDate"
          [selectionList]="this.selectableDate"
          (selectionChange)="this.onSlipDateChange($event)"></account-menu-selection-utils>
      </ng-container>
    </ng-container>
  </div>
  <div class="slips-required-text text">{{ 'Slips_Text_1' | t }}</div>
  <div class="ticket-cards-container" *ngIf="slipsList">
    <div class="one-ticket text" *ngFor="let item of slipsList | sortBy : true : 'CreateDateIso'; let i = index">
      <div id="ticket_detail_id_{{ item.SlipId }}" class="ticket-detail" (click)="toggleTicketDetails(item.SlipId)">
        <div class="ticket-card-left-container">
          <div class="ticket-date">
            {{ item.CreateDateIso | dateFormat : 'dd/MM/yyyy H:mm:ss' }}
          </div>
          <div class="ticket-type">
            <b>{{ item.SlipType }} </b>
          </div>
          <div class="ticket-stake">
            {{ 'Total_Stake' | t }}
            <div class="stake-bg">{{ item.Amount }} {{ this._UserHelper.customerUser?.Symbol }}</div>
          </div>
          <div class="possible-winning">
            {{ 'Possible_winnings' | t }}
            <b>{{ item.PossibleGain }} {{ this._UserHelper.customerUser?.Symbol }}</b>
          </div>
        </div>
        <div class="ticket-card-right-container">
          <div class="ticket-card-right-row">
            <div
              class="ticket-statu"
              [ngClass]="{
                open: item.StateId == 1,
                cancel: item.StateId == 2,
                won: item.StateId == 3,
                lost: item.StateId == 4,
                void: item.StateId == 5,
                cashout: item.StateId == 7,
                wait_cashout: item.StateId == 8
              }">
              <ng-container *ngIf="item.StateId == 1">
                {{ 'Open' | t }}
              </ng-container>
              <ng-container *ngIf="item.StateId == 2">
                {{ 'Cancel' | t }}
              </ng-container>
              <ng-container *ngIf="item.StateId == 3">
                <div class="item-state-container">
                  <div class="item-row-up">{{ 'Won' | t }}</div>
                  <div class="item-row-price">{{ item.Gain }} {{ _UserHelper.customerUser?.Symbol }}</div>
                </div>
              </ng-container>
              <ng-container *ngIf="item.StateId == 4">
                {{ 'Lost' | t }}
              </ng-container>
              <ng-container *ngIf="item.StateId == 5">
                {{ 'Void' | t }}
              </ng-container>
              <ng-container *ngIf="item.StateId == 7">
                <div class="item-state-container">
                  <div class="item-row-up">{{ 'Cashout' | t }}</div>
                  <div class="item-row-price">{{ item.Gain }} {{ _UserHelper.customerUser?.Symbol }}</div>
                </div>
              </ng-container>
              <ng-container *ngIf="item.StateId == 8">
                <div class="item-state-container">
                  <div class="item-row-up">{{ 'Wait_Cashout' | t }}</div>
                  <div class="item-row-price">{{ item.Gain }} {{ _UserHelper.customerUser?.Symbol }}</div>
                </div>
              </ng-container>
            </div>
            <div class="ticket-arrow-icon">
              <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (item.SlipId == this.openedPanelId ? 'up' : 'down')"></image-loader-utils>
            </div>
          </div>
        </div>
      </div>

      <div
        id="ticket-slips-dropdown-container"
        class="ticket-slips-dropdown-container"
        *ngIf="item.SlipId == this.openedPanelId || item.SlipId == this._UiHelper.selectedSlipDetail">
        <slip-detail-component [inputSlipId]="item.SlipId" [inputStateId]="item.StateId"></slip-detail-component>
      </div>
    </div>
  </div>
</div>
